import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface TsLinkLandConfig {
  tslinkLand: string;
}

export const TsLinkLandConfig: TsLinkLandConfig = {
  tslinkLand: environment.tslinkLand,
};

export const TSLAND_LINK = new InjectionToken<TsLinkLandConfig>('TsLinkLandConfig');
